import {SellerError} from './SellerError.js'

export class InvalidSellerRequestSellerError extends SellerError {}
